import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const pageTabContainer = (theme: Theme) => css`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background-color: ${theme.palette.white.main};

  &::-webkit-scrollbar {
    width: 12px !important;
  }

  &::-webkit-scrollbar-track {
    border-radius: 0px !important;
    border: none !important;
    background-color: ${theme.palette.uintel.main}00 !important;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.palette.uintel.main}40 !important;
    border-radius: 0px !important;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: ${theme.palette.uintel.main}60 !important;
  }
`

export const contentContainer = css`
  flex-grow: 1;
  position: relative;
  width: 100%;
`

export const innerScrollContainer = () => css`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
  position: absolute;
  height: 100%;
  top: 0;
`
